import { useMutation, useQueryClient } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface DeleteArtifactVariables {
  id: string;
}

export const useDeleteArtifact = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: DeleteArtifactVariables) => {
      const response = await fetchAPI({
        method: 'DELETE',
        route: `artifacts/${id}`
      });
      return response;
    },
    onSuccess: () => {
      // Invalidate and refetch artifacts list
      queryClient.invalidateQueries({ queryKey: ['artifacts'] });
    }
  });
};

export default useDeleteArtifact;
